export default "__VITE_ASSET__DkFwkBQd__"